export default __webpack_public_path__ + "static/ministry-of-defence-913b4aa722edf73720b15399487bf09f.png";